import React, { useState } from "react";
import PropTypes from "prop-types";

//
import ScrollBar from "react-perfect-scrollbar";

//
import { Dropdown, InputGroup, FormControl } from "react-bootstrap";

//
import ImageBox from "./ImageBox";
import NothingToShow from "./NothingToShow";

//
import { getAllCoins, iconImage } from "../../redux/features/coins/actions";

function CoinTypeDropdown({
  filters,
  activeFilter,
  action,
  title,
  fit = false,
  full = false,
  align = "end",
  coin = false,
  allCoins = false,
  isInvalid = false,
}) {

  const [search, setSearch] = useState("");
  const [searchingTimeout, setSearchingTimeout] = useState(false);

  const [loading, setLoading] = useState(false);
  const [allCoinsList, setAllCoinsList] = useState([]);

  const search_coin = (value) => {
    setSearch(value);

    if (allCoins) {
      clearTimeout(searchingTimeout);

      setSearchingTimeout(
        setTimeout(() => {
          get_all_coins(value);
        }, 1000)
      );
    }
  };

  /**
   * Get All Coins
   */
  const get_all_coins = async (value) => {
    // start loading
    setLoading(true);

    // request
    await getAllCoins(value).then((res) => {
      if (res) {
        setAllCoinsList(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  const filteredCoin = () => {
    var items = filters,
      coin = search;

    if (!coin) {
      return items;
    }

    coin = coin.trim().toLowerCase();

    items = items.filter((item) => {
      if (
        item.name.toLowerCase().indexOf(coin) !== -1 ||
        item.symbol.toLowerCase().indexOf(coin) !== -1
      ) {
        return item;
      }
    });

    // Return an array with the filtered data
    return items;
  };

  const on_toggle = (e) => {
    if (e) {
      console.log(document.getElementById('coin-input'));
    }
  };

  return (
    <Dropdown className="coin-type mb-0" align={align} onToggle={on_toggle}>
      <Dropdown.Toggle
        className={`${coin ? "coin" : ""} ${full ? "full" : ""} ${
          isInvalid ? "is-invalid" : ""
        }`}
      >
        {title && <>{!coin && <span className="title">{title} : </span>}</>}

        {!coin ? (
          <span>{activeFilter.symbol ? activeFilter.symbol : "All Coins"}</span>
        ) : (
          <>
            {activeFilter.symbol ? (
              <div>
                {!allCoins && <ImageBox src={iconImage(activeFilter.symbol)} />}

                <span>{activeFilter.name}</span>
                <span className="text-muted ms-1">({activeFilter.symbol})</span>
              </div>
            ) : (
              "Choose coin"
            )}
          </>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className={fit ? "fit" : ""}>
        <InputGroup>
          <InputGroup.Text>
            <i className="las la-search"></i>
          </InputGroup.Text>
          <FormControl
            id="coin-input"
            placeholder="Type coin"
            className="ps-0"
            value={search}
            onChange={(e) => search_coin(e.target.value)}
          />
        </InputGroup>
        <ScrollBar>
          {allCoins ? (
            <>
              {search ? (
                <>
                  {loading ? (
                    <NothingToShow text="Loading..." />
                  ) : (
                    <>
                      {allCoinsList.length ? (
                        <>
                          {allCoinsList.map((item, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => action(item)}
                              className="d-flex align-items-center"
                            >
                              {item.symbol && (
                                <>
                                  <span>{item.name}</span>
                                  <span>({item.symbol})</span>
                                </>
                              )}
                            </Dropdown.Item>
                          ))}
                        </>
                      ) : (
                        <NothingToShow text="Nothing to show" />
                      )}
                    </>
                  )}
                </>
              ) : (
                <NothingToShow text="Search Coin" />
              )}
            </>
          ) : (
            <>
              {filteredCoin().map((item, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => action(item)}
                  className="d-flex align-items-center"
                >
                  {item.symbol && (
                    <>
                      <ImageBox src={iconImage(item.symbol)} />
                      <span>{item.name}</span>
                      <span>({item.symbol})</span>
                    </>
                  )}
                </Dropdown.Item>
              ))}
            </>
          )}
        </ScrollBar>
      </Dropdown.Menu>
    </Dropdown>
  );
}

CoinTypeDropdown.propTypes = {
  filters: PropTypes.array,
  activeFilter: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  title: PropTypes.string,
  fit: PropTypes.bool,
  full: PropTypes.bool,
  align: PropTypes.string,
  coin: PropTypes.bool,
  allCoins: PropTypes.bool,
};

export default CoinTypeDropdown;
